import * as React from 'react';

import { trackShowMoreClick } from './tracking';
import { IRecomendedOfferSchema } from '../../types/recommendedOffer';

interface IUseTrackShowRecommendationsParams {
  recommendations: IRecomendedOfferSchema[];
  slidesToShow: number;
  offerId: number;
}

export const useTrackShowMoreClick = ({
  recommendations,
  slidesToShow,
  offerId,
}: IUseTrackShowRecommendationsParams) => {
  const [shownRecommendationIds, setShownRecommendationIds] = React.useState<Set<number>>(new Set());

  const handleSlideChange = React.useCallback(
    (currentSlide: number) => {
      const visibleSlides: number[] = [];

      for (let i = 0; i < slidesToShow && currentSlide + i < recommendations.length; i++) {
        visibleSlides.push(currentSlide + i);
      }

      const newRecommendations = visibleSlides
        .map(index => recommendations[index])
        .filter(recommendation => !shownRecommendationIds.has(recommendation.offerId))
        .map((recommendation, arrayIndex) => ({
          id: recommendation.offerId,
          position: visibleSlides[arrayIndex] + 1,
        }));

      if (newRecommendations.length > 0) {
        trackShowMoreClick({ offerId, recommendations: newRecommendations });

        setShownRecommendationIds(prev => {
          const newSet = new Set(prev);
          newRecommendations.forEach(rec => newSet.add(rec.id));

          return newSet;
        });
      }
    },
    [recommendations, shownRecommendationIds, slidesToShow, offerId],
  );

  return { handleSlideChange };
};
